//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { IRootScopeService, ITimeoutService } from 'angular';

import template from '@legacy-components/content/collections-closable-sidebar-filters/collections-closable-sidebar-filters.html';
import { LibraryTrackingIds } from '../libraryConstants';

export class CollectionsClosableSidebarFilters {
  public excludedSummaryKeys: string[] | undefined;
  public showCloseButton: boolean;
  public dataTrackingId: string = LibraryTrackingIds.SIDEBAR_FILTERS;
  public selectedStreamType: string;

  public closeClicked;

  constructor(
    private $rootScope: IRootScopeService,
    private $timeout: ITimeoutService,
  ) {}

  public $onInit() {
    this.excludedSummaryKeys = [
      ...(this.excludedSummaryKeys || []),
      'isDistributed',
    ];

    if (
      angular.isUndefined(this.showCloseButton) ||
      this.showCloseButton === null
    ) {
      this.showCloseButton = true;
    }
  }

  public onCloseClicked() {
    this.$timeout(() => {
      this.$rootScope.$broadcast('iso-layout');
    }, 0);
    this.closeClicked();
  }
}

angular.module('curalate').component('collectionsClosableSidebarFilters', {
  bindings: {
    initialFilters: '<',
    launchContext: '<?',
    closeClicked: '&',
    collectionId: '<',
    excludedSummaryKeys: '<',
    showCloseButton: '<?',
    selectedStreamType: '<?',
  },
  template,
  controller: ['$rootScope', '$timeout', CollectionsClosableSidebarFilters],
});
